import React, { Component } from 'react'
import { Tabs, TabPanel, TabList, Tab } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import SellingCallOut from '../sections/sellingCallOut.js'
import './bookingCalendarTabs.css'

class BookingCalendarTabs extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const {
      paymenModuleHeader,
      pickdropTiming,
      locationOfDelivery,
      pricingSummary,
      checkoutButton,
      bikeData,
    } = this.props
    return (
      <div className="booking-tabs-wrapper">
        <Tabs>
          <TabList className="tabs-title-list">
            {bikeData.for_sale ? (
              <>
                <Tab>
                  <strong>Rent it</strong>
                </Tab>
                <Tab>
                  <strong>Own it</strong>
                </Tab>
              </>
            ) : (
              <Tab className="not-for-sale">
                <strong className="book-now-header">Rent it</strong>
              </Tab>
            )}
          </TabList>

          <TabPanel>
            <div className="rent-it-wrapper">
              {paymenModuleHeader}
              {pickdropTiming}
              {locationOfDelivery}
              {pricingSummary}
              {checkoutButton}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="own-it-wrapper">
              <SellingCallOut
                motorcycleUUID={bikeData.bike_uuid_id}
                isPartner={bikeData.is_partner}
                sellPriceCents={bikeData.sale_price_cents}
                sellPriceCurrency={bikeData.sale_price_currency}
                sellerAvatarCloudinaryID={
                  bikeData.bike_owner_avatar_cloudinary_public_id
                }
                sellerID={bikeData.bike_owner_id}
                sellerName={bikeData.bike_owner_name}
                ownerLink={bikeData.owner_link}
                monthlyPriceCents={bikeData.sale_price_monthly_cents}
                monthlyPriceCurrency={bikeData.sale_price_monthly_currency}
              />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    )
  }
}

export default BookingCalendarTabs
